/******/ (() => { // webpackBootstrap
class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.recommendationsDrawer = this.closest('[data-cart-drawer-recommendations]');
    this.fetchRecommendations = this.fetchRecommendations.bind(this);
    this.renderRecommendations = this.renderRecommendations.bind(this);
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({key: 'component-cart-recommendations'});
    this.fetchRecommendations();
  }

  async fetchHtml(url) {
    try {
      const response = await fetch(url);
      console.log('[cart-recs] fetch', response.status, url);
      if (response.ok) {
        return await response.text();
      }
    } catch (error) {
      console.error('[cart-recs] Failed to fetch cart recommendations:', error);
    }
    return null;
  }

  hasRecommendations(html) {
    const content = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-recommendations')?.innerHTML;
    return !!content && content.trim().length > 0;
  }

  async fetchRecommendations() {
    if (!this.url) {
      console.warn('[cart-recs] data-cart-recommendations-url attribute missing');
      return;
    }

    const productIds = (this.getAttribute('data-cart-product-ids') || '').split(',').filter(Boolean);
    let foundHtml = null;

    if (productIds.length === 0) {
      /* ===== Old liquid (no product id list): use the URL exactly as given ===== */
      console.warn('[cart-recs] data-cart-product-ids missing - update snippets/cart-drawer.liquid');
      foundHtml = await this.fetchHtml(this.url);
    } else {
      /* ===== Try each cart product (most expensive first), show the first one that returns related products ===== */
      for (const productId of productIds) {
        const html = await this.fetchHtml(`${this.url}&product_id=${productId}&intent=related`);
        if (html && this.hasRecommendations(html)) {
          console.log('[cart-recs] using product', productId);
          foundHtml = html;
          break;
        }
      }
    }

    if (!foundHtml) console.warn('[cart-recs] no recommendations found, hiding drawer');
    this.renderRecommendations(foundHtml || '');
  }

  renderRecommendations(html) {
    const updatedContent = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-recommendations')?.innerHTML;
    
    if (!updatedContent || updatedContent.trim().length === 0) {
      /* ===== If no recommendations, hide the secondary drawer ===== */
      this.closest('cart-drawer')?.classList.add('hide-recommendations');
    } else {
      /* ===== If recommendations, update content ===== */
      this.innerHTML = updatedContent;
      this.closest('cart-drawer')?.classList.remove('hide-recommendations');

      /* ===== Prevent mobile content shift with each fetch by fixing the parent height and re-calculating after each fetch ===== */
      if (window.matchMedia('only screen and (max-width: 767px)').matches) {
        this.parentElement.style.height = 'auto';
        this.parentHeight = this.parentElement.getBoundingClientRect().height;
        this.parentElement.style.height = '';
        document.documentElement.style.setProperty('--cart-recommendations-height', `${this.parentHeight}px`);
      }
    }
  }

  get url() {
    return this.getAttribute('data-cart-recommendations-url');
  }
}

customElements.define('cart-recommendations', CartRecommendations);
/******/ })()
;
